import Switch from '../../../shared/switch-routes/main';
import React from 'react';

const isRocket = process.env.CPA_ENV === 'rocket';

const SwitchCustom = props => {
	return <Switch
		intl={props.intl}
		places={[
			{ name: 'payout-requests', title: `Requests` },
			{ name: 'payout-register-requests', title: `Requests register` },
			{ name: 'stat-pay-requests', title: `Requests stat` }

		].concat(
			(props.can('payout_requests_review') || props.can('payout_requests_view_matrix_and_history'))
				? [
					{ name: 'request-history', title: `Requests history` },
					{ name: 'risk-payouts', title: `Risk payouts` }
				]
				: []
		).concat(!isRocket &&
      (props.can('payout_requests_review') || props.can('payout_requests_view_matrix_and_history'))
			? [
				{ name: 'payout-reqs-lists/payout-matrix', title: `Payout matrix` },
				{ name: 'payout-reqs-lists/payout-scaling', title: `Payout requests scaling` }
			]
			: []
		).concat(!isRocket
			? [{ name: 'payout-reqs-lists/payout-scaling', title: `Payout requests scaling` }]
			: []
		)}
	/>;
};

export default SwitchCustom;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/components/other/switch.js